import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  listRomaniaDescription,
  updateRomaniaDescription,
} from "../redux/actions/aboutRomaniaAction";
import { ROMANIA_DESCRIPTION_UPDATE_RESET } from "../redux/constants/aboutRomaniaConstant";

const EditRomaniaScreen = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listRomaniaDescriptionState = useSelector(
    (state) => state.listRomaniaDescription
  );
  const { descriptions } = listRomaniaDescriptionState;
  const romaniaDescriptionEdit = useSelector(
    (state) => state.romaniaDescriptionEdit
  );
  const { success } = romaniaDescriptionEdit;
  const [description, setDescription] = useState("");
  const handleProductForm = (e) => {
    e.preventDefault();
    dispatch(updateRomaniaDescription(description, uuid));
  };

  const handleCkEditorChange = (e, editor) => {
    setDescription(editor.getData());
  };

  useEffect(() => {
    dispatch(listRomaniaDescription());
    if (success) {
      navigate("/about-romania");
      dispatch({ type: ROMANIA_DESCRIPTION_UPDATE_RESET });
    }
  }, [success]);
  return (
    <Layout>
      <PageTitle title="Edit Description of Romania" />
      <div className="card">
        <div className="card-body">
          <form onSubmit={handleProductForm}>
            <div className="col-12 mb-3">
              <CKEditor
                editor={ClassicEditor}
                class="form-control"
                placeholder="Description of Job"
                style={{ width: "100%" }}
                onChange={(e, editor) => {
                  handleCkEditorChange(e, editor);
                }}
                data={descriptions && descriptions.description}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Edit Product
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default EditRomaniaScreen;
